/* =========================================================
   VESTIMENTA – theme.js  (ein Skript, keine doppelten Listener)
   ========================================================= */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (!designMode) root.classList.add('js');

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function esc(t) { var d = doc.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }

  /* ---------- Geld ---------- */
  function formatMoney(cents) {
    var fmt = (window.VM && window.VM.money_format) || '{{amount_with_comma_separator}} €';
    cents = Math.round(Number(cents) || 0);
    function fmtNum(n, dec, th, dc) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s[0] + (s[1] ? dc + s[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  window.vmFormatMoney = formatMoney;

  /* ---------- Overlay / Drawer ---------- */
  var overlay = null;
  function lock(on) { doc.body.style.overflow = on ? 'hidden' : ''; }
  function closeAll() {
    $$('.cart-drawer.is-open, .mobile-menu.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    $$('.drawer-overlay.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    lock(false);
  }
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-overlay], [data-menu-overlay], [data-cart-close], [data-menu-close]')) { e.preventDefault(); closeAll(); }
  });

  /* ---------- Mobile-Menü ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open]');
    if (!t) return;
    e.preventDefault();
    var m = $('#MobileMenu'), o = $('[data-menu-overlay]');
    if (m) { m.classList.add('is-open'); if (o) o.classList.add('is-open'); lock(true); }
  });

  /* ---------- Header-Schatten ---------- */
  (function () {
    var h = $('[data-header]'); if (!h) return;
    var on = false;
    function upd() { var y = window.scrollY > 8; if (y !== on) { on = y; h.classList.toggle('is-scrolled', y); } }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  })();

  /* ---------- Teilen ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]'); if (!b) return;
    var url = b.getAttribute('data-url'), title = b.getAttribute('data-title') || doc.title;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var old = b.innerHTML; b.textContent = 'Link kopiert';
        setTimeout(function () { b.innerHTML = old; }, 1600);
      }).catch(function () {});
    }
  });

  /* ---------- Ankündigungsleiste ---------- */
  $$('[data-announce]').forEach(function (bar) {
    var items = $$('.announce__item', bar); if (items.length < 2) return;
    var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, speed);
  });

  /* ---------- Horizontale Reihen ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail-btn]'); if (!b) return;
    var rail = doc.getElementById(b.getAttribute('data-rail-btn')); if (!rail) return;
    var first = rail.firstElementChild; var step = first ? first.getBoundingClientRect().width + 16 : 300;
    rail.scrollBy({ left: b.getAttribute('data-dir') === 'prev' ? -step : step, behavior: 'smooth' });
  });

  /* ---------- Einblenden beim Scrollen ---------- */
  function reveal() {
    var els = $$('.reveal:not(.is-in)'); if (!els.length) return;
    if (!('IntersectionObserver' in window) || designMode) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { $$('.reveal:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight) el.classList.add('is-in'); }); }, 1500);
  }

  /* =======================================================
     WARENKORB
     ======================================================= */
  var Cart = {
    data: null,
    open: function () {
      var d = $('#CartDrawer'), o = $('[data-cart-overlay]');
      if (!d) { window.location.href = '/cart'; return; }
      d.classList.add('is-open'); if (o) o.classList.add('is-open'); lock(true);
      setTimeout(function () { try { d.focus(); } catch (e) {} }, 50);
    },
    fetch: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.data = c; Cart.render(c); return c; });
    },
    add: function (id, qty) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (d) { return Cart.fetch().then(function () { return d; }); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (c) { Cart.data = c; Cart.render(c); return c; })
        .catch(function (err) { Cart.fetch(); if (err && err.description) alertMsg(err.description); });
    },
    render: function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      $$('[data-cart-count-text]').forEach(function (el) { el.textContent = c.item_count; });
      var box = $('[data-cart-items]'); if (!box) return;
      var foot = $('[data-cart-foot]'), up = $('[data-cart-upsell]');
      if (!c.item_count) {
        box.innerHTML = '<div class="cart-empty"><p>Dein Warenkorb ist leer.</p><a class="btn btn--outline" href="/collections/all">Weiter shoppen</a></div>';
        if (foot) foot.hidden = true; if (up) up.hidden = true;
      } else {
        box.innerHTML = c.items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="line__variant">' + esc(it.variant_title) + '</p>' : '';
          var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<p class="line__disc">' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</p>'; }).join('');
          var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
          return '<div class="line" data-key="' + esc(it.key) + '">' +
            '<a href="' + esc(it.url) + '">' + (img ? '<img class="line__img" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="84" height="112" loading="lazy">' : '<span class="line__img"></span>') + '</a>' +
            '<div><p class="line__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' + variant +
            '<div class="line__row"><div class="qty"><button type="button" data-qty="-1" aria-label="Weniger">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Mehr">+</button></div>' +
            '<div class="line__price">' + was + formatMoney(it.final_line_price) + '</div></div>' + disc +
            '<button type="button" class="line__remove" data-remove>Entfernen</button></div></div>';
        }).join('');
        if (foot) foot.hidden = false;
        if (up) {
          var ids = c.items.map(function (i) { return String(i.product_id); });
          var threshold = (window.VM && window.VM.free_shipping) || 0;
          var gap = (!c.currency || c.currency==='EUR') ? Math.max(0, threshold - c.total_price) : 0;
          var candidates = $$('[data-upsell-id]', up).map(function (m) {
            var price = Number(m.getAttribute('data-upsell-price') || 0);
            return { el: m, price: price, type:m.getAttribute('data-upsell-type')||'', inCart: ids.indexOf(m.getAttribute('data-upsell-id')) > -1 };
          }).filter(function (x) { return !x.inCart; });
          candidates.sort(function(a,b){return a.price-b.price;});
          var keep=candidates.map(function(x){return x.el;});
          var rail=$('.cart-upsell__rail',up), previousScroll=rail?rail.scrollLeft:0;
          $$('[data-upsell-id]',up).forEach(function(m){m.hidden=keep.indexOf(m)===-1;});
          if(rail){keep.forEach(function(m){rail.appendChild(m);});rail.scrollLeft=previousScroll;}
          var ut = $('[data-upsell-title]', up);
          if (ut) ut.textContent = 'Kleine Extras für deinen Look';
          up.hidden = keep.length === 0;
        }
      }
      var tot = $('[data-cart-total]'); if (tot) tot.textContent = formatMoney(c.total_price);
      try { window.dispatchEvent(new Event('vm:cart')); } catch (e) {}
      var sav = $('[data-savings]');
      var saved = Math.max(0, Number(c.total_discount || 0));
      var labels = (window.VM && window.VM.cart_labels) || {};
      var breakdown = $('[data-cart-breakdown]');
      if (breakdown) breakdown.hidden = !c.item_count || saved <= 0;
      var before = $('[data-cart-before]'); if (before) before.textContent = formatMoney(c.original_total_price);
      var allocations = {};
      function recordDiscount(title, amount) { if (amount > 0) allocations[title] = (allocations[title] || 0) + amount; }
      (c.items || []).forEach(function(item) { (item.line_level_discount_allocations || []).forEach(function(d) { recordDiscount(d.discount_application.title, d.amount); }); });
      (c.cart_level_discount_applications || []).forEach(function(d) { recordDiscount(d.title, d.total_allocated_amount); });
      var discountBox = $('[data-cart-discounts]');
      if (discountBox) discountBox.innerHTML = Object.keys(allocations).map(function(title) { return '<div class="vm-cart-breakdown__row vm-cart-breakdown__discount"><span>' + esc(title) + '</span><strong>−' + formatMoney(allocations[title]) + '</strong></div>'; }).join('');
      if (sav) { sav.hidden = !c.item_count || saved <= 0; sav.textContent = (labels.saved || 'Du sparst __AMOUNT__ durch angewendete Rabatte.').replace('__AMOUNT__', formatMoney(saved)); }
      var offerHint=$('[data-look-cart-offer]'); if(offerHint) offerHint.hidden=!c.item_count;
      var duo = $('[data-duo-hint]'); if (duo) duo.hidden = c.item_count !== 1;
      var gift = $('[data-vm-gift]');
      if (gift) {
        var giftAvailable = gift.getAttribute('data-available') === 'true';
        gift.hidden = !!(c.currency && c.currency !== 'EUR');
        var giftThreshold = Number(gift.getAttribute('data-threshold'));
        var remaining = Math.max(0, giftThreshold - c.total_price);
        var label = $('[data-vm-gift-message]', gift);
        if (label) label.textContent = giftAvailable ? (remaining > 0 ? gift.getAttribute('data-remaining').replace('__AMOUNT__', formatMoney(remaining)) : gift.getAttribute('data-unlocked')) : (remaining > 0 ? 'Noch ' + formatMoney(remaining) + ' bis zum kostenlosen Versand nach Deutschland' : 'Versandkostenfrei nach Deutschland');
        var meter = $('[data-vm-gift-meter]', gift);
        if (meter) meter.value = Math.max(0, Math.min(giftThreshold, c.total_price));
        gift.classList.toggle('is-unlocked', remaining === 0);
        var choices = $('[data-vm-gift-choices]', gift);
        if (choices) {
          choices.hidden = remaining > 0 || !giftAvailable;
          choices.disabled = remaining > 0 || giftPending;
          var selectedGift = String((c.attributes || {})['VM Geschenk Variant ID'] || '');
          $$('[data-vm-gift-choice]', choices).forEach(function(input) { input.checked = input.value === selectedGift; });
        }
        $$('[data-vm-offer-quantity]', gift).forEach(function(el) { el.classList.toggle('is-earned', c.item_count >= Number(el.getAttribute('data-vm-offer-quantity'))); });
      }
      var th = (window.VM && window.VM.free_shipping) || 0, st = $('[data-ship-text]'), fill = $('[data-ship-fill]');
      var shippingBar=$('[data-ship-bar]'); if(shippingBar) shippingBar.hidden=!!(c.currency && c.currency!=='EUR');
      if (th > 0 && st && fill && (!c.currency || c.currency==='EUR')) {
        var rest = th - c.total_price;
        fill.style.width = Math.min(100, Math.round(c.total_price / th * 100)) + '%';
        st.innerHTML = rest > 0 ? 'Noch <strong>' + formatMoney(rest) + '</strong> bis zum kostenlosen Versand' : '<strong>Kostenloser Versand</strong> ist freigeschaltet';
      }
    }
  };
  window.VMCart = Cart;
  var giftPending = false;
  doc.addEventListener('change', function(e) {
    var input = e.target.closest('[data-vm-gift-choice]');
    if (!input || giftPending) return;
    var gift = input.closest('[data-vm-gift]');
    var status = $('[data-vm-gift-status]', gift);
    var choices = $('[data-vm-gift-choices]', gift);
    if (!Cart.data || Cart.data.currency !== 'EUR' || Cart.data.total_price < Number(gift.getAttribute('data-threshold'))) return;
    giftPending = true;
    choices.disabled = true;
    if (status) status.textContent = status.getAttribute('data-saving');
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'VM Geschenk Variant ID': input.value, 'VM Geschenk': input.getAttribute('data-gift-title') } })
    }).then(function(r) { return r.json().then(function(c) { if (!r.ok) throw c; return c; }); })
      .then(function(c) { giftPending = false; Cart.data = c; Cart.render(c); if (status) status.textContent = status.getAttribute('data-saved'); })
      .catch(function() { giftPending = false; choices.disabled = false; if (status) status.textContent = gift.getAttribute('data-save-error'); Cart.fetch().catch(function() {}); });
  });
  doc.addEventListener('click', function(e) {
    if (giftPending && e.target.closest('[href="/checkout"], [name="checkout"], [data-checkout]')) e.preventDefault();
  }, true);
  doc.addEventListener('submit', function(e) {
    if (giftPending && e.target.matches('form[action$="/cart"]')) e.preventDefault();
  }, true);
  window.vmAddToCart = function (id, btn) { return quickAdd(id, btn); };

  function alertMsg(m) { var p = $('[data-savings]'); if (p) { p.hidden = false; p.textContent = m; } }

  function quickAdd(id, btn) {
    var txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    return Cart.add(id, 1).then(function () {
      if (btn) { btn.textContent = '✓ Hinzugefügt'; setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 1500); }
      Cart.open();
    }).catch(function (d) {
      if (btn) { btn.textContent = (d && d.description) ? 'Nicht verfügbar' : 'Fehler – erneut versuchen'; setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 2000); }
    });
  }

  doc.addEventListener('change', function(e){
    var select=e.target.closest('[data-look-variant]'); if(!select) return;
    var card=select.closest('[data-look-item]'), selected=select.options[select.selectedIndex];
    if(!card || !selected) return;
    var price=Number(selected.getAttribute('data-price')); var label=$('[data-look-price]',card);
    if(label) label.textContent=formatMoney(price);
    var button=$('[data-quick-add]',card); if(button) button.setAttribute('data-quick-add',select.value);
    if(card.hasAttribute('data-upsell-price')) card.setAttribute('data-upsell-price',String(price));
  });

  doc.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); var look=q.closest('[data-look-item]'), choice=look && $('[data-look-variant]',look); quickAdd(choice?choice.value:q.getAttribute('data-quick-add'), q); return; }
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); Cart.open(); Cart.fetch(); return; }
    var line = e.target.closest('.cart-drawer .line');
    if (line) {
      var key = line.getAttribute('data-key');
      var qb = e.target.closest('[data-qty]');
      if (qb) { var cur = parseInt($('.qty span', line).textContent, 10) || 1; Cart.change(key, Math.max(0, cur + parseInt(qb.getAttribute('data-qty'), 10))); }
      if (e.target.closest('[data-remove]')) Cart.change(key, 0);
    }
  });

  /* ---------- Warenkorbseite (/cart) ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-page-qty]'); if (!b) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line'), 10), qty = parseInt(b.getAttribute('data-page-qty'), 10);
    $$('[data-page-qty]').forEach(function (x) { x.disabled = true; });
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () { window.location.reload(); }, function () { window.location.reload(); });
  });

  /* =======================================================
     PRODUKTSEITE
     ======================================================= */
  function initProduct(sec) {
    var dataEl = $('[data-product-json]', sec); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var variants = P.variants, sel = P.selected.slice(), current = null;
    var form = $('[data-product-form]', sec) || $('form[action*="/cart/add"]', sec);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-atc]', sec), err = $('[data-atc-error]', sec), qtyInput = $('[data-qty-input]', sec);
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), saveEl = $('[data-save]', sec), imageSaleBadge = $('[data-pdp-sale-badge]', sec);
    var stockEl = $('[data-stock]', sec), stickyPrice = $('[data-sticky-price]'), stickyBtn = $('[data-sticky-atc]');

    function find() { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null; }
    function markOptions() {
      $$('[data-opt-index]', sec).forEach(function (b) {
        var i = parseInt(b.getAttribute('data-opt-index'), 10), val = b.getAttribute('data-value');
        // lieferbar mit allen anderen gewaehlten Optionen?
        var ok = variants.some(function (v) { if (!v.available || v.options[i] !== val) return false; for (var j = 0; j < sel.length; j++) { if (j !== i && v.options[j] !== sel[j]) return false; } return true; });
        b.classList.toggle('is-unavailable', !ok);
        b.classList.toggle('is-selected', sel[i] === val);
        b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
      });
      $$('[data-opt-label]', sec).forEach(function (l) { l.textContent = sel[parseInt(l.getAttribute('data-opt-label'), 10)] || ''; });
    }
    function stock(v) {
      if (!stockEl) return;
      var mode = stockEl.getAttribute('data-stock-mode') || 'always_limited';
      var thr = parseInt(stockEl.getAttribute('data-low-threshold') || (P.low_stock_threshold || 5), 10) || 5;
      var lowTxt = stockEl.getAttribute('data-stock-low-text') || 'Nur noch wenige verfügbar';
      var okTxt = stockEl.getAttribute('data-stock-ok-text') || 'Auf Lager';
      stockEl.className = 'stock';
      if (!v) { stockEl.classList.add('stock--out'); stockEl.innerHTML = '<span class="stock__dot"></span>Diese Kombination gibt es nicht'; return; }
      if (!v.available) { stockEl.classList.add('stock--out'); stockEl.innerHTML = '<span class="stock__dot"></span>Derzeit ausverkauft'; return; }
      var tracked = !!v.inventory_management;
      var qty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : parseInt(v.inventory_quantity || 0, 10);
      var low = false;
      if (mode === 'always_limited') {
        low = true;
      } else if (tracked && qty > 0 && qty <= thr) {
        low = true;
      } else if (!tracked) {
        low = false; // untracked → green
      }
      if (low) {
        stockEl.classList.add('stock--low');
        stockEl.innerHTML = '<span class="stock__dot stock__dot--pulse"></span>' + esc(lowTxt);
      } else {
        stockEl.innerHTML = '<span class="stock__dot"></span>' + esc(okTxt);
      }
    }
    function update(pushUrl) {
      var v = find();
      if (err) err.hidden = true;
      markOptions(); stock(v);
      if (!v) { current = null; idInput.value = ''; btn.disabled = true; btn.textContent = 'Nicht verfügbar'; if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Nicht verfügbar'; } return; }
      current = v; idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (typeof refreshOffer === 'function') refreshOffer(v);
      if (cmpEl) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        cmpEl.hidden = !sale;
        if (saveEl) saveEl.hidden = !sale;
        if (imageSaleBadge) imageSaleBadge.hidden = !sale;
        if (sale) {
          var saleActive = true;
          try {
            if (window.VM && window.VM.sale_ends_at) {
              saleActive = Date.now() < Date.parse(window.VM.sale_ends_at);
            }
          } catch (e) {}
          var saleLabel = saleActive ? ('Du sparst ' + formatMoney(v.compare_at_price - v.price)) : 'Sale';
          cmpEl.textContent = formatMoney(v.compare_at_price);
          if (saveEl) saveEl.textContent = saleLabel;
          if (imageSaleBadge) imageSaleBadge.textContent = saleLabel;
        }
      }
      var label = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      btn.disabled = !v.available; btn.textContent = label;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = label; }
      if (v.featured_media && v.featured_media.id) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', sec);
        if (slide) {
          var gal = slide.parentElement;
          if (window.innerWidth < 990) gal.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          else if (pushUrl) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
      if (pushUrl && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }

    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt-index]'); if (!b) return;
      sel[parseInt(b.getAttribute('data-opt-index'), 10)] = b.getAttribute('data-value');
      update(true);
    });
    $$('[data-opt-select]', sec).forEach(function (s) { s.addEventListener('change', function () { sel[parseInt(s.getAttribute('data-opt-select'), 10)] = s.value; update(true); }); });

    $$('[data-qty-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () { var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10); qtyInput.value = Math.max(1, Math.min(99, n)); if (typeof refreshOffer === 'function') refreshOffer(current); });
    });

    var offerLadder = $('[data-offer-ladder]', sec);
    function refreshOffer(v) {
      if (!offerLadder || !v) return;
      var pct = parseFloat(offerLadder.getAttribute('data-duo-pct')) || 10;
      var single = $('[data-single-offer-price]', offerLadder), duo = $('[data-duo-offer-price]', offerLadder), save = $('[data-duo-offer-save]', offerLadder), compare = $('[data-duo-offer-compare]', offerLadder);
      if (single) single.textContent = formatMoney(v.price);
      var saving = Math.round(v.price * 2 * pct / 100), total = v.price * 2 - saving;
      if (duo) duo.textContent = formatMoney(total);
      if (save) save.textContent = formatMoney(saving);
      if (compare) compare.textContent = formatMoney(v.price * 2);
      var ship = $('[data-offer-shipping]', offerLadder), shipText = $('[data-offer-shipping-text]', offerLadder);
      if (ship && shipText) shipText.textContent = 'Kostenfreier Versand ab ' + formatMoney(parseInt(ship.getAttribute('data-threshold'), 10)) + ' nach Rabatten. Deinen Fortschritt siehst du im Warenkorb.';
    }
    if (offerLadder) {
      $$('[data-offer-qty]', offerLadder).forEach(function(o){ o.addEventListener('click', function(){ var q=parseInt(o.getAttribute('data-offer-qty'),10)||1; qtyInput.value=q; $$('[data-offer-qty]', offerLadder).forEach(function(x){x.classList.toggle('is-active',x===o);}); refreshOffer(current); }); });
    }

    var submitting = false;
    function submit() {
      if (submitting || !current || btn.disabled) return;
      submitting = true;
      var submittedVariant = current;
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      Cart.add(submittedVariant.id, q).then(function () {
        submitting = false; update(false);
        Cart.open();
        if (window.fbq) { try { fbq('track', 'AddToCart', { content_ids: [String(submittedVariant.id)], content_type: 'product', value: submittedVariant.price * q / 100, currency: (window.VM && VM.currency) || 'EUR' }); } catch (x) {} }
      }).catch(function (d) {
        submitting = false; update(false);
        if (err) { err.textContent = (d && d.description) || 'Das hat leider nicht geklappt. Bitte versuche es erneut.'; err.hidden = false; }
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { submit(); });

    // Galerie-Punkte (mobil)
    var main = $('[data-gallery]', sec), dots = $$('[data-dot]', sec);
    if (main && dots.length) {
      main.addEventListener('scroll', function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { main.scrollTo({ left: k * main.clientWidth, behavior: 'smooth' }); }); });
    }

    // Sticky-Leiste zeigen, sobald der Kauf-Button aus dem Bild ist
    var sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var visible = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-visible', visible); sticky.setAttribute('aria-hidden', String(!visible)); if(stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1; }).observe(btn);
    }

    // Bild groß anzeigen
    var lb = $('[data-lightbox]'), lbImg = $('[data-lb-img]', lb || doc), shots = $$('[data-zoom]', sec), idx = 0;
    function showLb(i) {
      if (!lb || !shots.length) return;
      idx = (i + shots.length) % shots.length;
      lbImg.src = shots[idx].getAttribute('data-zoom');
      lbImg.alt = shots[idx].alt || '';
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); lock(true);
    }
    function hideLb() { if (!lb) return; lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); lock(false); }
    if (lb) {
      shots.forEach(function (im, i) { im.addEventListener('click', function () { if (window.innerWidth >= 990) showLb(i); }); });
      $('[data-lb-close]', lb).addEventListener('click', hideLb);
      $('[data-lb-prev]', lb).addEventListener('click', function () { showLb(idx - 1); });
      $('[data-lb-next]', lb).addEventListener('click', function () { showLb(idx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) hideLb(); });
      doc.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') hideLb();
        if (e.key === 'ArrowLeft') showLb(idx - 1);
        if (e.key === 'ArrowRight') showLb(idx + 1);
      });
    }

    // Hinweis „noch X € bis Gratis-Versand“
    var fs = $('[data-free-ship]');
    if (fs) {
      var th = (window.VM && window.VM.free_shipping) || 0;
      window.addEventListener('vm:cart', function () {
        var c = Cart.data; if (!th || !c || !c.item_count) { fs.hidden = true; return; }
        var rest = th - c.total_price;
        fs.hidden = false;
        fs.innerHTML = rest > 0
          ? 'Noch <strong>' + formatMoney(rest) + '</strong> bis zum kostenlosen Versand'
          : '<strong>Kostenloser Versand</strong> ist freigeschaltet';
      });
      if (Cart.data) window.dispatchEvent(new Event('vm:cart'));
    }

    update(false);
  }

  /* ---------- Bewertungs-Slider (Auto-Play) ---------- */
  function initAutoRails() {
    $$('[data-autoplay]').forEach(function (rail) {
      var ms = (parseInt(rail.getAttribute('data-autoplay'), 10) || 0) * 1000; if (!ms || rail.children.length < 2) return;
      var paused = false;
      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });
      rail.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || doc.hidden) return;
        var w = rail.firstElementChild.getBoundingClientRect().width + 16;
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: w, behavior: 'smooth' });
      }, ms);
    });
  }

  /* ---------- Sendungsverfolgung ---------- */
  doc.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-track-form]'); if (!f) return;
    e.preventDefault();
    var v = ($('input', f).value || '').replace(/\s+/g, ''), err = $('[data-track-err]', f.parentElement);
    if (v.length < 8) { if (err) err.hidden = false; return; }
    if (err) err.hidden = true;
    window.open(f.getAttribute('data-url') + encodeURIComponent(v), '_blank', 'noopener');
  });

  /* ---------- Cookie-Einstellungen ---------- */
  doc.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cookie-settings]')) return;
    e.preventDefault();
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') cp.showPreferences();
  });

  /* ---------- Start ---------- */
  function init() {
    reveal();
    $$('[data-product-section]').forEach(initProduct);
    initAutoRails();
    Cart.fetch().catch(function () {});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();

  // Theme-Editor: Sections neu initialisieren
  doc.addEventListener('shopify:section:load', function (e) {
    reveal(); initAutoRails();
    var p = e.target.querySelector('[data-product-section]'); if (p) initProduct(p);
  });
})();

